export enum InvitationErrorType {
  CODE_INVALID = 'codeInvalid',
  CODE_ALREADY_USED = 'codeAlreadyUsed',
  CODE_REQUIRED = 'codeRequired',
}
